// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, node, string } from 'prop-types'

const buttonClasses = 'btn btn-md hover-inverse margin-left-1 margin-right-1 heading-font'

const DeleteConfirmation = props => {
  const {
    closeModal,
    confirmAction,
    idRoot,
    modalHeading,
    modalMessage,
  } = props

  return (
    <div className={'path-details-footer-modal'}>
      <h3 className={'center-text uppercase padding-half'}>
        <span
          className={'text-blue-dark'}
          id={`${idRoot}-heading`}>
          {modalHeading}
        </span>
        <span className={'alert-decoration'} />
      </h3>
      <p
        className={'padding-half center-text'}
        id={`${idRoot}-message`}>
        {modalMessage}
      </p>
      <div className={'display-flex justify-content-center padding-top-1'}>
        <button
          className={`bg-grey-blue ${buttonClasses}`}
          id={`${idRoot}-cancel`}
          onClick={closeModal}>
          {'Cancel'}
        </button>
        <button
          className={`bg-red ${buttonClasses}`}
          id={`${idRoot}-delete`}
          onClick={confirmAction}>
          {'Delete'}
        </button>
      </div>
    </div>
  )
}

DeleteConfirmation.propTypes = {
  closeModal: func.isRequired,
  confirmAction: func.isRequired,
  idRoot: string,
  modalHeading: string.isRequired,
  modalMessage: node.isRequired,
}

DeleteConfirmation.defaultProps = {
  idRoot: 'delete-confirmation-modal',
}

export default DeleteConfirmation
